<template>
    <div :class="`DshFlatTable control-${mode}`">
        <!-- 表格内容 -->
        <div :class="{
            'DshFlatTable-readonly': !canEdit,
            'DshFlatTable-block': true
        }">
            <table
                class="table"
                border="1"
                cellspacing="0"
                bordercolor="#CFD9EB"
            >
                <!-- 表头 -->
                <thead>
                    <tr class="table-head">
                        <th
                            v-for="(col, colIndex) in showColumns"
                            :key="colIndex"
                            :style="getThStyle(col,1)"
                            @click="clickTh(col, colIndex)"
                        >
                            <span>
                                <i
                                    v-if="col._required"
                                    style="color:red"
                                >*</i>
                                <template v-if="col._type === 'selection'">
                                    <Checkbox
                                        :indeterminate="indeterminate"
                                        :value="checkAll"
                                        @click.prevent.native="handleCheckAll"
                                    ></Checkbox>
                                </template>
                                <template v-else>
                                    {{ col._name }}
                                </template>
                                <Tooltip
                                    v-if="col._description"
                                    transfer
                                    max-width="200"
                                >
                                    <Icon
                                        class="table-head-description"
                                        custom="bico-font bico-explain"
                                    ></Icon>
                                    <div slot="content">
                                        <span style="font-weight:normal;">{{ col._description }}</span>
                                    </div>
                                </Tooltip>
                            </span>
                        </th>
                    </tr>
                </thead>

                <!-- 行数据 -->
                <tbody
                    v-if="data.length"
                    :style="{ 'max-height': height+'px' }"
                >
                    <tr
                        v-for="(row, rowIndex) in data"
                        :key="rowIndex"
                        class="table-row"
                    >
                        <td
                            v-for="(col, colIndex) in showColumns"
                            :key="colIndex"
                            :style="getThStyle(col)"
                            @click="clickTd(row, col)"
                        >
                            <dsh-unit
                                :key="col._key"
                                :mode="mode"
                                :canEdit="canEdit | filterCanEdit(col, row)"
                                :formData="row"
                                :formItem="col"
                                :isShare="isShare"
                                :rowIndex="rowIndex"
                                @change="$dispatchEvent(operationMap.changeVal, col, row, arguments)"
                            ></dsh-unit>
                        </td>
                    </tr>
                </tbody>

                <!-- 脚 -->
                <tfoot v-else>
                    <tr>
                        <td
                            class="table-row-nodata"
                            :colspan="showColumns.length"
                        >暂无数据……</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- 添加行 -->
        <dsh-buttons
            class="DshFlatTable-create"
            :list="$getOperationList(['create'])"
            @click="$dispatchEvent($event, null, null, data)"
        ></dsh-buttons>
    </div>
</template>

<script>
    import DshUnit from "../unit/DshUnit.vue";

    export default {
        name: "DshFlatTable",
        components: {
            DshUnit
        },
        props: {
            mode: {
                type: String,
                default: "default"
            },
            canEdit: {
                type: Boolean,
                default: true
            },
            columns: {
                type: Array,
                default () {
                    return [];
                }
            },
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            rowDefault: {
                type: Object,
                default () {
                    return {};
                }
            },
            height: {
                type: Number | String,
                default () {
                    return 600;
                }
            },
            isShare: Boolean,
            useSelection: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                getThStyle (col, type) {
                    if (["index", "selection"].includes(col._type)) {
                        col.width = col._width || 46;
                        col._align = col._align || "left";
                    } else if (["text", "textarea", "email"].includes(col._type)) {
                        col.width = col._width || 200;
                        col._align = col._align || "left";
                    } else if (["idcard"].includes(col._type)) {
                        col.width = col._width || 190;
                        col._align = col._align || "left";
                    } else if (["phone"].includes(col._type)) {
                        col.width = col._width || 130;
                        col._align = col._align || "left";
                    } else if (["number"].includes(col._type)) {
                        col.width = col._width || 120;
                        col._align = col._align || "left";
                    } else if (["date"].includes(col._type)) {
                        col._align = col._align || "left";
                        switch (col._dateType) {
                        case "date": col.width = col._width || 120; break;
                        case "year": col.width = col._width || 96; break;
                        case "month": col.width = col._width || 120; break;
                        case "time": col.width = col._width || 120; break;
                        case "datetime": col.width = col._width || 180; break;
                        default: col.width = 120; break;
                        }
                    } else if (["switch"].includes(col._type)) {
                        col.width = col._width || 80;
                        col._align = col._align || "center";
                    } else if (["select"].includes(col._type)) {
                        col.width = col._width || 120;
                        col._align = col._align || "center";
                    } else if (["checkbox"].includes(col._type)) {
                        col.width = col._width || 180;
                        col._align = col._align || "left";
                    } else if (["cascader"].includes(col._type)) {
                        col.width = col._width || 150;
                        col._align = col._align || "left";
                    } else if (["region"].includes(col._type)) {
                        col.width = col._width || 212;
                        col._align = col._align || "left";
                    } else if (["file", "image"].includes(col._type)) {
                        col.width = col._width || 170;
                        col._align = col._align || "center";
                    } else if (["flatTable", "cascaderTable", "editor"].includes(col._type)) {
                        col.width = col._width || 100;
                        col._align = col._align || "center";
                    } else if (["departments"].includes(col._type)) {
                        col.width = col._width || 100;
                        col._align = col._align || "left";
                    } else if (["users"].includes(col._type)) {
                        col.width = col._width || 120;
                        col._align = col._align || "left";
                    } else if (["reference"].includes(col._type)) {
                        col.width = (col._name ? col._name.length * 14 : 36) + 60;
                        col._align = col._align || "left";
                    } else if (["referenceBy"].includes(col._type)) {
                        col.width = col._width || 100;
                        col._align = col._align || "left";
                    } else {
                        col.width = col._width || 120;
                        col._align = col._align || "left";
                    }
                    let styleObj = {
                        width: col.width && `${col.width}px`,
                        minWidth: col.width && `${col.width}px`,
                        maxWidth: col.width && `${col.width}px`,
                        padding: "5px 8px",
                        textAlign: col._align
                    };
                    type !== undefined ? styleObj.cursor = "pointer" : styleObj.height = "30px";
                    return styleObj;
                },

                // 全选功能
                checkAllGroup: []
            };
        },
        computed: {
            indeterminate () {
                return this.checkAllGroup.length ? (this.checkAllGroup.length !== this.data.length) : false;
            },
            checkAll () {
                return this.checkAllGroup.length ? (this.checkAllGroup.length === this.data.length) : false;
            },
            operationMap () {
                if (this.canEdit) {
                    return {
                        create: {
                            name: "添加一行",
                            type: "create",
                            icon: "md-add",
                            size: "default",
                            long: true,
                            event: "clickCreate"
                        },
                        delete: {
                            name: "删除",
                            type: "delete",
                            color: "red",
                            btnType: "text",
                            // icon: "md-trash",
                            event: "clickDelete"
                        },
                        // expand: {
                        //     name: "展开",
                        //     type: "expand",
                        //     event: "clickExpand"
                        // },
                        changeVal: {
                            name: "改变输入框值",
                            type: "changeVal",
                            event: "changeVal"
                        }
                    };
                } else {
                    return {};
                }
            },
            showColumns () {
                let showColumns = [
                    {
                        _id: this.$ObjectID().str,
                        _name: "序号",
                        _type: "index",
                        _key: "index"
                    },
                    ...this.columns.filter(colItem => colItem._displayType !== "hide")
                ];

                // 是否使用全选
                if (this.useSelection) {
                    showColumns.unshift({
                        _id: this.$ObjectID().str,
                        _name: "全选",
                        _type: "selection",
                        _key: "selection",
                        _align: "center",
                        render: (h, { row, index, column }) => {
                            return h("Checkbox", {
                                props: {
                                    value: this.checkAllGroup.some(checkItem => checkItem._id === row._id)
                                },
                                on: {
                                    input: ($event) => this.checkAllGroupChange($event, row)
                                }
                            });
                        }
                    });
                }

                this.canEdit && showColumns.push({
                    _id: this.$ObjectID().str,
                    _name: "操作",
                    _type: "operation",
                    _key: "operation",
                    _width: 80,
                    render: (h, params) => {
                        return h("dsh-buttons", {
                            props: {
                                list: this.$getOperationList(["delete"])
                            },
                            on: {
                                click: (operationItem) => {
                                    this.$dispatchEvent(operationItem, params.row, params.index, this.data);
                                }
                            }
                        });
                    }
                });
                return showColumns;
            },
            _rowDefault () {
                return this.columns.reduce((obj, formItem) => {
                    return Object.assign(obj, { [formItem._key]: this.rowDefault[formItem._key] });
                }, {});
            }
        },
        created () {},
        methods: {
            // 点击表头
            clickTh (col, colIndex) {
                this.$emit("clickTh", col, colIndex);
            },
            // 点击单元格
            clickTd (row, col) {},

            // 点击 -添加行
            clickCreate (operationItem, row, index, list) {
                const newRow = {
                    ...this.$deepCopy(this._rowDefault),
                    _id: this.$ObjectID().str
                };
                const newRowIndex = list.push(newRow);
                this.$forceUpdate(); // 自定义页中点击添加一行没有更新页面
                this.change("createRow", null, newRow, newRowIndex);
            },
            // 点击 -删除行
            clickDelete (operationItem, row, rowIndex, list) {
                this.$Modal.confirm({
                    title: "警告",
                    content: "确定删除吗？",
                    onOk: () => {
                        list.splice(rowIndex, 1);
                        this.change("deleteRow", null, row, rowIndex);
                    }
                });

            },
            // 输入框值改变
            changeVal (operationItem, col, row, params) {
                this.change("changeVal", col, row, params);
            },
            // // 点击 -打开行
            // clickExpand (operationItem, row, index, list) {

            // },

            // 是否全选
            handleCheckAll () {
                if (this.checkAllGroup.length) {
                    this.checkAllGroup = [];
                } else {
                    this.checkAllGroup = this.data;
                }
                this.selectAll();
            },
            // 单个选中事件
            checkAllGroupChange (val, row) {
                if (val) {
                    this.checkAllGroup.push(row);
                } else {
                    this.checkAllGroup = this.checkAllGroup.filter(checkItem => checkItem._id !== row._id);
                }
                this.selectChange(row, val);
            },
            selectChange (row, val) {
                this.$emit("selectChange", this.checkAllGroup, row, val);
            },
            selectAll () {
                this.$emit("selectAll", this.checkAllGroup);
            },
            change (...params) {
                this.$emit("change", { list: this.data, rowDefault: this.rowDefault }, ...params);
            }
        },
        filters: {
            filterCanEdit (canEdit, col, row) {
                if (col.dependRowCanEdit) {
                    return row.canEdit !== false;
                } else {
                    return canEdit;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/list/DshFlatTable.vue